<div class="header">
    <div class="title">
        @if (!id) {
            <inline-svg src="home.svg" class="title-icon inactive"
                        color="#272727"
            ></inline-svg>
            <span>Project Management</span>
        }
        @if (id) {
            <inline-svg src="home.svg" class="title-icon"
                        (click)="goToList()"
                        color="#7F8F98"
                        hoverColor="#7F8F98"
            ></inline-svg>
            <inline-svg src="arrow-middle.svg" class="title-arrow-icon"
                        color="#7F8F98"
                        hoverColor="#7F8F98"
            ></inline-svg>
            <span> {{ project?.name }}</span>
        }
    </div>
    <div class="spacer"></div>
    @if (id) {
        <div class="actions">
            @if (!project.is_archived) {
                <button mat-button mat-raised-button class="frmg-primary-button" (click)="openOnMap()">Open on Map
                </button>
            }
            <button mat-button mat-raised-button class="frmg-secondary-button" (click)="shareProject()">
                <inline-svg src="Share.svg" class="action-icon"
                            color="#A5B5BD"
                            hoverColor="#7F8F98"
                ></inline-svg>
            </button>
            @if (project.is_owned_by_current_user) {
                <button mat-button mat-raised-button class="frmg-secondary-button"
                        (click)="archiveProject()">
                    <inline-svg [src]="project.is_archived ? 'unarchive.svg' : 'archived.svg'" class="action-icon"
                                color="#A5B5BD"
                                hoverColor="#7F8F98"
                    ></inline-svg>
                </button>
                <button mat-button mat-raised-button class="frmg-secondary-button"
                        (click)="deleteProject()">
                    <inline-svg src="remove.svg" class="action-icon"
                                color="#A5B5BD"
                                hoverColor="#7F8F98"
                    ></inline-svg>
                </button>
            }
            @if (project?.shared_with?.length) {
                <div class="shared-users">
                    @if (project.shared_with.length <= 3) {
                        @for (user of project.shared_with; track user; let i = $index) {
                            @if (i < 3) {
                                <frmg-user-logo [user]="user"></frmg-user-logo>
                            }
                        }
                    } @else {
                        @for (user of project.shared_with; track user; let i = $index) {
                            @if (i < 2) {
                                <frmg-user-logo [user]="user"></frmg-user-logo>
                            }
                        }
                        <frmg-user-logo
                                [user]="{id:'0',teams:[],email:('+' + (project.shared_with.length - 2))}"></frmg-user-logo>
                    }
                </div>
            }
        </div>
    }
</div>
<div class="body">
    <router-outlet></router-outlet>
</div>

